import { NdfDemandsCalculationsFiltered } from '@interfaces/a-organizar/ndfDemandsCalculationsFiltered';

export interface DemandState {
  demand: NdfDemandsCalculationsFiltered | null;
}

export const initialDemandState: DemandState = {
  demand: null,
};
